
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/render",
      function () {
        return require("private-next-pages/render/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/render"])
      });
    }
  